import { Form } from 'components/organisms';
import { Button } from 'components/atoms';
import { MagellanPopups } from 'components/molecules';
import { userFormInitialValues } from 'components/organisms/forms/client-user/ClientUserForm';
import { useParamId } from 'hooks/useParamId';
import i18next from 'i18next';
import middleware from 'middleware';
import { useGetClientUser, useDeleteClientUser } from 'services/clientUserManagment';
import { PiPencilSimpleLine } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { onErrorShowToast } from 'utils/service/errorHandler';
import { PopupActions } from 'reactjs-popup/dist/types';
import { DefaultError } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { usePutForcePasswordChange } from 'services/auth/forcePasswordChange';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const ClientUser = () => {
  const userId = useParamId('users');
  const { data: user, isLoading: isUserLoading } = useGetClientUser(userId);
  const navigate = useNavigate();
  const i18nextPrefix = 'user';
  const { t } = useTranslation();
  const isLoading = isUserLoading;

  const { mutateAsync: deleteUser } = useDeleteClientUser();
  const { mutateAsync: forcePasswordChange } = usePutForcePasswordChange(userId);

  const onRemoveUser = async (actions: PopupActions) => {
    if (user?.email) {
      await deleteUser(user.email, {
        onError: (error: DefaultError) => {
          actions.close();
          onErrorShowToast(error);
        },
        onSuccess: () => {
          navigate('/client-users');
        },
      });
    }
  };

  const onForcePasswordChange = async () => {
    if (user?.id) {
      await forcePasswordChange(user?.id, {
        onError: (error: DefaultError) => {
          onErrorShowToast(error);
        },
      })
    }
  }

  return (
    <Form.ClientUser
      i18nextPrefix={i18nextPrefix}
      tittle={user?.userName ?? i18next.t('user.title.individual')}
      initialValues={
              user ? middleware.clientUser.queryToForm(user) : userFormInitialValues
            }
      backPath='client-users'
      onSubmit={() => { }}
      status={{displayMode: true, isLoading}}
      topbarContent={
        <div className='flex  justify-end gap-2'>
          {/* <Button
            variant={BUTTON_VARIANT.warning}
            onClick={onForcePasswordChange}
          >
            <Button.Text
              text={t('button.force-a-password-reset')}
            />
          </Button> */}
          <Button
            isClear
            onlyIcon
            onClick={() => {
              if (user) {
                navigate(`/client-users/edit/${userId}`, { replace: true });
              }
            }}
          >
            <Button.Description description={t('button.edit')} />


            <Button.Icon icon={<PiPencilSimpleLine />} />
          </Button>
          <MagellanPopups.DeleteWarning
            name={user?.userName}
            onRemove={onRemoveUser}
          />
        </div>
      }
    />
  );
};

export default ClientUser;
